import { render, staticRenderFns } from "./CourseLicenseTemplateList.vue?vue&type=template&id=4f33fa48&"
import script from "./CourseLicenseTemplateList.vue?vue&type=script&lang=ts&"
export * from "./CourseLicenseTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports